export default {
    palm: 'screen and (max-width: 700px)',
    lap: 'screen and (min-width: 700px) and (max-width: 1023px)',
    portable: 'screen and (max-width: 1023px)',
    'lap-and-up': 'screen and (min-width: 700px)',
    desk: 'screen and (min-width: 1024px)',
    'desk-wide': 'screen and (min-width: 1230px)',
};
